import { Component, Output, EventEmitter, Input,OnInit } from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent implements OnInit {
  @Output()
  refreshLista = new EventEmitter<string>();

  @Input()
  pagParams:any={
    hasNextPage:false,
    hasPrevPage:false,
    totalPages:[],
    page:0
  } 
  constructor() { }

  ngOnInit(): void {
  }

  refreshPagination(info:any){
    this.refreshLista.emit(info)
  }
}
